const initialState = true;

const calendarPageReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SHOW_CALENDAR_PAGE':
            return action.payload;
        default:
            return state;
    }
};

export default calendarPageReducer;